/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Avatar from 'funifier-nice-avatar';
import Box from 'components/ui/box';
import ReactModal from 'react-modal';
import { useEffect, useRef, useState } from 'react';
import { TbBulbFilled, TbSearch } from 'react-icons/tb';
import InputMask from 'react-input-mask';
import { findPlayer } from 'services/profile.service';
import { User } from 'types/user';
import { RiCloseLine } from 'react-icons/ri';
import { IoMdCloseCircle } from 'react-icons/io';
import { useAuth } from 'context/AuthContext';
import { Colaboracao, FocoNoCliente, Inovacao, MandouBem, Resolutividade, Lideranca, Uau, Valeu } from 'components/icons';
import { actionLog } from 'services/actionlog.service';
import { BehaviorLabel, GetBehaviorDescription, GetBehaviorLabel, GetMoedaDescription, GetMoedaLabel } from 'utils/strings';

import './style.scss';
import { UserAvatar } from 'components/user-avatar';

import FeedbackGeral from 'assets/img/comportamento/bg-feedback-moedas.png';
import FeedbackMandou from 'assets/img/comportamento/mandou.png';
import FeedbackUau from 'assets/img/comportamento/uau.png';
import FeedbackValeu from 'assets/img/comportamento/valeu.png';

import { getPlayerInfo, getServerTime } from 'services/dashboard.service';
import TextEditor from 'components/text-editor';
import { AiOutlineWarning } from 'react-icons/ai';
import Modal from './Modal/Index';
import { BiInfoCircle } from 'react-icons/bi';
import { convertEmojis } from 'utils/helpers';
import Tippy from '@tippyjs/react';
import { useModal } from 'context/ModalContext';
import { useHelp } from 'context/HelpContext';

const maskTemplate = 'F9999999';

export default function Reconhecer() {
  const navigate = useNavigate();
  const params = useParams();
  const pearsonRef = useRef<HTMLDivElement>(null);
  const behaviorRef = useRef<HTMLDivElement>(null);
  const recognitionRef = useRef<HTMLDivElement>(null);
  const feedbackRef = useRef<HTMLDivElement>(null);
  const sendedRef = useRef<HTMLDivElement>(null);
  const feedbackServer = useRef<HTMLDivElement>(null);

  const { user, refreshUser, currentCycle } = useAuth();
  const { showModal, closeModal } = useModal();
  const { helpData } = useHelp();

  const searchRef = useRef<any>();
  const messageRef = useRef<any>();

  const [isOpen, setIsOpen] = useState(true);

  const [searchResults, setSearchResults] = useState<User[]>([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [searched, setSearched] = useState(false);
  const [target, setTarget] = useState<User>();
  const [behavior, setBehavior] = useState<string>();
  const [coin, setCoin] = useState<string | undefined>();
  const [message, setMessage] = useState<string>();
  const [messageLength, setMessageLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [playerInfo, setPlayerInfo] = useState<any>({});
  const [showModalItem, setshowModalItemItem] = useState(false);

  const [step, setStep] = useState(0);

  const [submitMessage, setSubmitMessage] = useState<string | undefined>();
  const [hasSubmitError, setHasSubmitError] = useState<boolean>(false);

  const [mask, setMask] = useState('');

  useEffect(() => {
    const close = (e: any) => {
      if (e.keyCode === 27) {
        handleCloseModal();
      }
      console.log(e.keyCode);
    };
    window.addEventListener('keydown', close);

    return () => window.removeEventListener('keydown', close);
  }, []);

  useEffect(() => {
    if (!!pearsonRef && pearsonRef.current) {
      setTimeout(() => {
        pearsonRef?.current?.querySelector('h2')?.focus();
      }, 300);
    }
    if (!!behaviorRef && !!behaviorRef.current) {
      setTimeout(() => {
        behaviorRef?.current?.querySelector('h2')?.focus();
      }, 300);
    }

    if (!!recognitionRef && !!recognitionRef.current) {
      setTimeout(() => {
        recognitionRef.current?.querySelector('h2')?.focus();
      }, 300);
    }

    if (!!feedbackRef && !!feedbackRef.current) {
      setTimeout(() => {
        feedbackRef.current?.querySelector('h2')?.focus();
      }, 300);
    }

    if (!!sendedRef && !!sendedRef.current) {
      setTimeout(() => {
        sendedRef.current?.querySelector('a')?.focus();
      }, 300);
    }
  }, [step]);

  const minTextLength = 100;

  const maxTextLength = 600;

  ReactModal.setAppElement('#modal');

  const iconSize = 30;
  const Coins: any = {
    uau: (
      <div className="w-[30px]">
        <Uau size={iconSize} />
      </div>
    ),
    mandou: (
      <div className="w-[30px]">
        <MandouBem size={iconSize} />
      </div>
    ),
    valeu: (
      <div className="w-[30px]">
        <Valeu size={iconSize} />
      </div>
    ),
  };

  const CoinLabel: any = {
    uau: 'Arrasou',
    mandou: 'Top',
    valeu: 'Curti',
  };

  const Behaviors: any = {
    colaboracao: (
      <div className="w-[30px]">
        <Colaboracao size={iconSize} />
      </div>
    ),
    inovacao: (
      <div className="w-[30px]">
        <Inovacao size={iconSize} />
      </div>
    ),
    foco: (
      <div className="w-[30px]">
        <FocoNoCliente size={iconSize} />
      </div>
    ),
    resolutividade: (
      <div className="w-[30px]">
        <Resolutividade size={iconSize} />
      </div>
    ),
    lideranca: (
      <div className="w-[30px]">
        <Lideranca size={iconSize} />
      </div>
    ),
  };

  function handleChange() {
    if (searchRef.current) {
      const value = searchRef.current.value.toUpperCase();
      if (value.length > 1) {
        if (value[0].toUpperCase() === 'F' && !isNaN(value[1])) {
          setMask(maskTemplate);
        } else {
          setMask('');
          if (value === '_______') {
            searchRef.current.value = '';
          }
        }
      } else {
        setMask('');
      }
    }
  }

  async function handleSearch(e?: any) {
    if (e) {
      e.preventDefault();
    }
    try {
      const matricula = searchRef.current.value.replace('_', '');

      if (!matricula || matricula === user?._id) {
        return;
      }

      setSearching(true);
      const result = await findPlayer(searchRef.current.value);
      const filteredResults = result.filter((item: any) => item._id !== user?._id);
      if (filteredResults.length === 1) {
        setTarget(filteredResults[0]);
      } else {
        setSearchResults(filteredResults);

        setIsEmpty(filteredResults?.length === 0 && matricula.startsWith('F') && matricula.slice(1).match(/^[0-9]+$/) != null);
      }
      setSearching(false);
      setSearched(true);
    } catch (e) {
      setSearching(false);
    }
  }

  async function handleSubmit() {
    try {
      if (
        loading ||
        !target ||
        !behavior ||
        !coin ||
        !message ||
        !messageLength ||
        messageLength.textLength < minTextLength ||
        messageLength.fullLength > maxTextLength
      )
        return;

      setLoading(true);

      const serverTime = await getServerTime();

      if (
        !currentCycle?.status ||
        currentCycle.status !== 'open' ||
        serverTime > currentCycle.date_finish ||
        serverTime < currentCycle.date_start
      ) {
        return toast.error(`Não há fase disponível para envio de reconhecimentos.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      const log = await actionLog('me', 'reward_behavior', {
        target: target?._id,
        behavior,
        coin,
        message,
      });

      setLoading(false);
      setSubmitted(true);
      refreshUser();

      if (log.action && log.action.attributes.status && log.action.attributes.status !== 'OK') {
        setHasSubmitError(true);

        if (!!log?.action?.attributes?.systemMessage) {
          setSubmitMessage(log?.action?.attributes?.systemMessage);
        } else {
          setSubmitMessage('Ocorreu um erro com a sua solicitação. Por favor, tente novamente em alguns minutos.');
        }
      } else if (log.action && log.action.attributes.status && log.action.attributes.status === 'OK') {
        setHasSubmitError(false);

        if (!!log?.action?.attributes?.systemMessage) {
          setSubmitMessage(log?.action?.attributes?.systemMessage);
        } else {
          setSubmitMessage(
            'Você reconheceu um colega. Agradecemos por ajudar a tornar o ambiente colaborativo e agradável para trabalhar.',
          );
        }
      }
    } catch (e) {
      setLoading(false);
      setSubmitted(true);
      refreshUser();
      setSubmitMessage('Ocorreu um erro com a sua solicitação. Por favor, tente novamente em alguns minutos.');
      setHasSubmitError(true);
    }

    if (!!feedbackServer && !!feedbackServer.current) {
      setTimeout(() => {
        feedbackServer.current?.querySelector('h1')?.focus();
      }, 300);
    }
  }

  function reset() {
    setTarget(undefined);
    setBehavior(undefined);
    setCoin(undefined);
    setSubmitted(false);
    setLoading(false);
    setSubmitMessage(undefined);
    setHasSubmitError(false);
    setSearchResults([]);
    setSearching(false);
    setMessage(undefined);
    setMessageLength(undefined);
    setStep(0);
  }

  function handleCloseModal() {
    reset();
    navigate('../');
  }

  const getImgFeedback = (_coin: string) => {
    const imgs: any = {
      mandou: FeedbackMandou,
      uau: FeedbackUau,
      valeu: FeedbackValeu,
      geral: FeedbackGeral,
    };

    return imgs[_coin || 'geral'];
  };

  function hasEnoughCoins(coin_type: string) {
    try {
      if (!user) {
        return true;
      }

      if (!user?.point_categories?.point_behavior || user?.point_categories?.point_behavior < 100) {
        return false;
      }

      switch (coin_type) {
        case 'uau':
          if (user?.point_categories?.point_behavior - 300 >= 0) {
            return true;
          } else {
            return false;
          }
        case 'mandou':
          if (user?.point_categories?.point_behavior - 200 >= 0) {
            return true;
          } else {
            return false;
          }
        case 'valeu':
          if (user?.point_categories?.point_behavior - 100 >= 0) {
            return true;
          } else {
            return false;
          }
        default:
          return true;
      }
    } catch (e) {
      return true;
    }
  }

  function focusOnElement(selector: string) {
    const element: any = document.querySelector(selector);
    if (!!element) {
      element?.focus();
    }
  }

  function afterOpenModal() {
    focusOnElement('.modal-reconhecer h1');
  }

  function handleChangeMessage(content: string, contentLength: any) {
    setMessage(content);
    setMessageLength(contentLength);
  }

  useEffect(() => {
    async function playerCanView() {
      const serverTime = await getServerTime();

      if (
        !currentCycle?.status ||
        currentCycle.status !== 'open' ||
        serverTime > currentCycle.date_finish ||
        serverTime < currentCycle.date_start
      ) {
        toast.error(`Não há fase disponível para envio de reconhecimentos.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        return navigate('/');
      }

      const data = await getPlayerInfo(user?._id);
      setPlayerInfo(data);
    }

    if (!!currentCycle) {
      playerCanView();
    }
  }, [currentCycle, navigate]);

  useEffect(() => {
    setTimeout(() => {
      if (!searching && searchRef && searchRef.current && params && params.id) {
        searchRef.current.value = params.id;
        handleSearch();
      }
    }, 1000);
  }, [params]);

  useEffect(() => {
    if (
      !!target &&
      !!playerInfo &&
      Array.isArray(playerInfo.relacionamentos) &&
      !!playerInfo?.relacionamentos?.find((item: any) => item === target.extra.id)
    ) {
      setshowModalItemItem(true);
    }
  }, [target, playerInfo]);

  function showRetryButton() {
    if (submitMessage) {
      switch (submitMessage) {
        case 'Não existe fase aberta para envio de reconhecimento.':
          return false;
        case 'Você não possui saldo suficiente para reconhecer. Por favor, aguarde até a próxima distribuição.':
          return false;
        case 'Você já enviou o limite máximo de 300 pontos, para a mesma pessoa, neste mês.':
          return false;
        case 'Você não pode emitir reconhecimentos. Em caso de dúvidas, entre em contato com nossa equipe.':
          return false;
        case 'Você já fez esse reconhecimento ao mesmo usuário nesta fase.':
          return false;
        default:
          return true;
      }
    }
  }

  return (
    <ReactModal
      key={'modal-reconhecer'}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      onAfterOpen={afterOpenModal}
      onAfterClose={handleCloseModal}
      contentLabel="Modal Reconhecer"
      portalClassName="modal-reconhecer"
      overlayClassName="fixed z-20 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center overflow-hidden"
      contentElement={() => (
        <>
          {/* <Tesouro id="uau" x={3} y={83} /> */}
          {!submitted && (
            <Box className="relative bg-oxford-blue border-electric-blue p-1 lg:p-8 flex flex-col w-[90%] lg:max-w-screen-md justify-center items-center border-opacity-100 bg-opacity-100">
              <div className="flex justify-center items-center space-x-2 mb-3 mx-8">
                <h1
                  className="text-xl mt-4 lg:mt-0 lg:text-lg block text-center text-yellow"
                  tabIndex={0}
                  aria-label="Reconheça quem é FLAP 360°"
                >
                  Reconheça quem é FLAP 360°!
                </h1>

                {/* <div className="flex-1 space-y-2"> */}
                {/* <p>É rapidinho, você escolhe uma pessoa, um comportamento e a diz o quanto ela te impactou!</p> */}
                {/* </div> */}
              </div>

              {!!helpData && (
                <div className="mx-8 mb-5">
                  <p>
                    Possui dúvidas para enviar reconhecimento? Confira o tutorial em vídeo.
                    <button
                      aria-label="Reconheça quem FLAP 360°"
                      className="p-2 text-[#C2D2FF]"
                      onClick={() => showModal('help-video')}
                    >
                      ASSISTIR VÍDEO
                    </button>
                  </p>
                </div>
              )}
              <button
                className="absolute -top-5 -right-5 button-close"
                tabIndex={0}
                aria-label="Fechar modal ”Reconhecer colega”. Voltar para tela inicial"
                onClick={() => {
                  if (searchResults.length > 0) {
                    reset();
                  } else {
                    setIsOpen(false);
                  }
                }}
              >
                <IoMdCloseCircle size={48} className="text-slate-blue" />
              </button>
              <div className="mx-auto relative lg:container overflow-y-auto max-h-[85vh] pt-2">
                {!loading && !submitted && (
                  <div className="space-y-8">
                    <div className="relative flex flex-row items-center justify-around mx-8" aria-hidden={true}>
                      <div className="absolute z-0 w-full h-[1px] top-0 bottom-0 m-auto border-b border-white opacity-20"></div>
                      <div
                        className={`${
                          step === 0 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        1
                      </div>
                      <div
                        className={`${
                          step === 1 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        2
                      </div>
                      <div
                        className={`${
                          step === 2 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        3
                      </div>
                      <div
                        className={`${
                          step >= 3 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        4
                      </div>
                    </div>

                    {step === 0 && (
                      <div className="mx-8 step_0" ref={pearsonRef}>
                        <div className="space-x-4 ">
                          {!target && searchResults.length === 0 && !searching && (
                            <div>
                              <span className="screen-reader-text" tabIndex={0}>
                                Etapa 1 de 4 para reconhecer colega em andamento.
                              </span>
                              <div className="relative flex-1" tabIndex={0}>
                                <span className="text-alice-blue mb-3 block whitespace-nowrap text-base font-thin">
                                  Quem você gostaria de reconhecer?
                                </span>
                                {/* <input type="text" placeholder='Digite a matrícula' ref={ref=>searchRef.current = ref} className="w-full bg-black bg-opacity-30 text-xl text-yellow flex-1 rounded-xl p-2" /> */}
                                <div className="space-x-4 flex flex-row items-center justify-between">
                                  <form onSubmit={handleSearch} className="pl-1 -ml-1 flex-1">
                                    <input
                                      type="text"
                                      aria-label="Campo de busca. Em braco. Campo editável"
                                      placeholder="Digite o nome ou e-mail"
                                      style={{ fontSize: 16 }}
                                      className="w-full bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
                                      ref={(ref: any) => {
                                        searchRef.current = ref;
                                      }}
                                      onChange={e => handleChange()}
                                    />
                                    {/* <InputMask
                                        placeholder="Digite o nome ou a chave"
                                        alwaysShowMask={false}
                                        mask={mask}
                                        ref={(ref: any) => {
                                          searchRef.current = ref;
                                        }}
                                        onChange={(e) => handleChange()}
                                        inputMode="search"
                                        style={{ fontSize: 16 }}
                                        className="w-full bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
                                      /> */}
                                  </form>

                                  <TbSearch
                                    size={28}
                                    className="cursor-pointer hover:ring-2 mr-1 rounded-full"
                                    onClick={() => handleSearch()}
                                  />
                                </div>
                              </div>

                              {isEmpty && (
                                <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl">
                                  <div className="text-center pt-2 text-white font-base font-light">
                                    Verifique o e-mail que você está buscando, esse e-mail não consta na base de funcionário do
                                    FLAP 360°.
                                  </div>
                                </div>
                              )}

                              {!searching && searchResults.length === 0 && searched && (
                                <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl vai tomar no seu cu">
                                  <div className="text-center pt-2 text-white font-base font-light">
                                    Não encontrou quem procura? Experimente buscar por nome e sobrenome ou e-mail.
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          {searching && (
                            <>
                              <p className="animate-pulse text-white text-base font-thin p-3" tabIndex={0}>
                                Recuperando informações...
                              </p>
                            </>
                          )}

                          {!target && !!searchResults && searchResults.length > 0 && (
                            <div className="flex-1 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl list-options">
                              {searchResults.map((item, index) => (
                                <button
                                  key={item._id}
                                  onClick={() => setTarget(item)}
                                  aria-label={`Selecionar ${item.name}. Chave ${item._id}. Lotado na ${item.extra?.dependencia}`}
                                  className={`cursor-pointer hover:opacity-75 w-full flex flex-row items-center justify-between border-b border-prussian-blue pb-4 mb-4 text-left`}
                                >
                                  <div className="w-[44px] h-[44px] ml-2" aria-hidden={true} tabIndex={-1}>
                                    <UserAvatar
                                      aria-hidden={true}
                                      data={{
                                        image: item.image,
                                        ariaHidden: false,
                                        ...item.extra,
                                      }}
                                    />
                                  </div>
                                  <p className="flex-1 pl-3 pr-2" aria-hidden={true} tabIndex={-1}>
                                    <span className="block text-base font-semibold">{item.extra?.nome_guerra}</span>
                                    <span className="block text-xs font-thin">
                                      {item.name} ({item._id})
                                    </span>
                                    <span className="block text-xs font-thin" aria-hidden={true}>
                                      <span className="text-electric-blue uppercase">{item.extra?.dependencia}</span> -{' '}
                                      {item.extra?.funcao}
                                    </span>
                                  </p>
                                </button>
                              ))}
                              <div className="text-center pt-2 text-white font-base font-light">
                                Não encontrou quem procura? Experimente buscar por nome, sobrenome ou e-mail.
                              </div>
                            </div>
                          )}

                          {!!target && !searching && (
                            <div className="relative flex-1">
                              <h2 className="text-alice-blue mb-3 block whitespace-nowrap text-base font-thin">
                                Você está reconhecendo:
                                <span className="screen-reader-text" tabIndex={0}>
                                  Você está reconhecendo: {target.name}. Chave {target._id}. Lotado na {target.extra?.dependencia}
                                </span>
                              </h2>
                              <div className="flex-1 w-full flex flex-row items-center justify-between bg-rich-black bg-opacity-80 py-4 lg:px-8 rounded-3xl">
                                <div className="w-[44px] h-[44px] ml-2" aria-hidden={true}>
                                  <UserAvatar
                                    data={{
                                      image: target.image,
                                      ariaHidden: false,
                                      ...target.extra,
                                    }}
                                  />
                                </div>
                                <p className="flex-1 pl-3 pr-2" aria-hidden={true}>
                                  <span className="block text-base font-semibold">{target.extra?.nome_guerra}</span>
                                  <span className="block text-xs font-thin">
                                    {target.name} ({target._id})
                                  </span>
                                  <span className="block text-xs font-thin">
                                    <span className="text-electric-blue uppercase">{target.extra?.dependencia}</span> -{' '}
                                    {target.extra?.funcao}
                                  </span>
                                </p>

                                <RiCloseLine
                                  size={44}
                                  aria-label={'Excluir funcionário e voltar para campo de busca.'}
                                  tabIndex={0}
                                  className="cursor-pointer hover:ring-2 p-2 rounded-full text-slate-blue"
                                  onClick={() => reset()}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {step === 1 && (
                      <div className="block w-full step_1" ref={behaviorRef}>
                        <span className="screen-reader-text" tabIndex={0}>
                          Etapa 2 de 4 para reconhecer colega em andamento
                        </span>
                        <h2
                          className="block font-thin text-white text-base leading-none mb-5 px-5 lg:px-0  lg:mx-8"
                          aria-label={`Por qual comportamento você vai reconhecer ${
                            target?.extra?.nome_guerra ? target?.extra?.nome_guerra : target?.name?.split(' ')[0]
                          }`}
                          tabIndex={0}
                        >
                          Por qual comportamento você vai reconhecer{' '}
                          <strong className="text-electric-blue uppercase">
                            {target?.extra?.nome_guerra ? target?.extra?.nome_guerra : target?.name?.split(' ')[0]}
                          </strong>
                          ?
                        </h2>

                        <div
                          className={`${
                            behavior ? 'grid-items-reconhecer has-item' : 'grid-items-reconhecer'
                          } grid grid-cols-3 bg-oxford-blue-2 rounded-lg w-full p-4 lg:flex lg:flex-row items-center justify-between mt-5 text-xs lg:text-md`}
                        >
                          <button
                            onClick={() => setBehavior('colaboracao')}
                            tabIndex={0}
                            aria-label={`Selecionar Colaboração ${GetBehaviorDescription('colaboracao')}`}
                            className={`${
                              !behavior || behavior === 'colaboracao' ? '' : 'opacity-50'
                            } elem-1 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                          >
                            <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                              <Colaboracao size={'100%'} />
                            </div>
                            <p className="text-sm text-white m-0 p-0 font-thin">Colaboração</p>
                          </button>

                          <button
                            onClick={() => setBehavior('inovacao')}
                            tabIndex={0}
                            aria-label={`Selecionar Inovação ${GetBehaviorDescription('inovacao')}`}
                            className={`${
                              !behavior || behavior === 'inovacao' ? '' : 'opacity-50'
                            } elem-2 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                          >
                            <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                              <Inovacao size={'100%'} />
                            </div>
                            <p className="text-sm text-white m-0 p-0 font-thin">Inovação</p>
                          </button>

                          <button
                            onClick={() => setBehavior('foco')}
                            tabIndex={0}
                            aria-label={`Selecionar Foco no cliente ${GetBehaviorDescription('foco')}`}
                            className={`${
                              !behavior || behavior === 'foco' ? '' : 'opacity-50'
                            } elem-3 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                          >
                            <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                              <FocoNoCliente size={'100%'} />
                            </div>
                            <p className="text-sm text-white m-0 p-0 font-thin">Foco no cliente</p>
                          </button>

                          <button
                            onClick={() => setBehavior('resolutividade')}
                            tabIndex={0}
                            aria-label={`Selecionar Proatividade ${GetBehaviorDescription('resolutividade')}`}
                            className={`${
                              !behavior || behavior === 'resolutividade' ? '' : 'opacity-50'
                            } elem-4 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                          >
                            <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                              <Resolutividade size={'100%'} />
                            </div>
                            <p className="text-sm text-white m-0 p-0 font-thin">Proatividade</p>
                          </button>

                          <button
                            onClick={() => setBehavior('lideranca')}
                            tabIndex={0}
                            aria-label={`Selecionar Liderança Engajadora ${GetBehaviorDescription('lideranca')}`}
                            className={`${
                              !behavior || behavior === 'lideranca' ? '' : 'opacity-50'
                            } elem-5 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                          >
                            <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                              <Lideranca size={'100%'} />
                            </div>
                            <p className="text-sm text-white m-0 p-0 font-thin">Liderança Engajadora</p>
                          </button>

                          {!!behavior && (
                            <div
                              aria-hidden={true}
                              dangerouslySetInnerHTML={{
                                __html: GetBehaviorDescription(behavior),
                              }}
                              className="text-elem font-thin text-xs text-electric-blue block leading-tight"
                            ></div>
                          )}
                        </div>

                        <div className="bg-oxford-blue-2 lg rounded-lg w-full pb-4 md:hidden">
                          <div
                            className={`grid grid-cols-2 md:hidden gap-4  p-4 lg:flex-row items-center justify-between mt-5 text-xs lg:text-md`}
                          >
                            <button
                              onClick={() => setBehavior('colaboracao')}
                              aria-label="Comportamento Colaboração"
                              className={`${
                                !behavior || behavior === 'colaboracao' ? '' : 'opacity-50'
                              } elem-1 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <Colaboracao size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Colaboração</p>
                            </button>

                            <button
                              onClick={() => setBehavior('inovacao')}
                              aria-label="Comportamento Inovação"
                              className={`${
                                !behavior || behavior === 'inovacao' ? '' : 'opacity-50'
                              } elem-2 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <Inovacao size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Inovação</p>
                            </button>

                            <button
                              onClick={() => setBehavior('foco')}
                              aria-label="Comportamento Foco no cliente"
                              className={`${
                                !behavior || behavior === 'foco' ? '' : 'opacity-50'
                              } elem-3 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <FocoNoCliente size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Foco no cliente</p>
                            </button>

                            <button
                              onClick={() => setBehavior('resolutividade')}
                              aria-label="Comportamento Proatividade"
                              className={`${
                                !behavior || behavior === 'resolutividade' ? '' : 'opacity-50'
                              } elem-4 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <Resolutividade size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Proatividade</p>
                            </button>
                            <button
                              onClick={() => setBehavior('lideranca')}
                              aria-label="Comportamento Liderança Engajador"
                              className={`${
                                !behavior || behavior === 'lideranca' ? '' : 'opacity-50'
                              } elem-5 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <Lideranca size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Liderança Engajadora</p>
                            </button>
                          </div>
                          {!!behavior && (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: GetBehaviorDescription(behavior),
                              }}
                              className="text-elem font-thin text-xs text-electric-blue block leading-tight text-center px-5"
                            ></div>
                          )}
                        </div>
                      </div>
                    )}

                    {step === 2 && (
                      <div className="step_2" ref={recognitionRef}>
                        {!hasEnoughCoins('uau') && !hasEnoughCoins('mandou') && !hasEnoughCoins('valeu') && (
                          <div>
                            <p className="text-yellow p-2 text-center border border-yellow rounded-lg lg:rounded-full mx-8">
                              Você não possui saldo de pontos para reconhecer. Aguarde até a próxima distribuição.
                            </p>
                          </div>
                        )}

                        {(hasEnoughCoins('uau') || hasEnoughCoins('mandou') || hasEnoughCoins('valeu')) && (
                          <>
                            <h2
                              className="block font-thin text-white text-base leading-none mb-5 px-6 lg:px-0 lg:mx-8"
                              aria-label="Escolha o tipo de Reconhecimento que você deseja enviar:"
                              tabIndex={0}
                            >
                              Escolha o tipo de <strong>Reconhecimento</strong> que você deseja enviar:
                            </h2>

                            <div>
                              <div
                                className={`w-full ${
                                  !!coin ? 'grid-items-reconhecer has-item' : 'grid-items-reconhecer'
                                } moedas bg-oxford-blue-2 rounded-lg w-full py-4 px-8 lg:flex lg:flex-row items-center justify-between mt-5 text-xs lg:text-md text-yellow`}
                              >
                                <button
                                  disabled={!hasEnoughCoins('uau')}
                                  onClick={() => (hasEnoughCoins('uau') ? setCoin('uau') : null)}
                                  aria-label={`Reconhecimento Arrasou. Equivale a 300 pontos. ${GetMoedaDescription('uau')}`}
                                  className={`${!coin || coin === 'uau' ? '' : 'opacity-50'} ${
                                    !hasEnoughCoins('uau') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-1 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-col space-y-2 items-center mb-3">
                                    <div className="coin flex-1">
                                      <Uau size={50} />
                                    </div>
                                    <p className="font-normal text-xs leading-tight text-white">Arrasou</p>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {!hasEnoughCoins('uau') ? 'Saldo insuficiente' : '300 pontos'}
                                  </p>
                                </button>
                                <button
                                  disabled={!hasEnoughCoins('mandou')}
                                  onClick={() => (hasEnoughCoins('mandou') ? setCoin('mandou') : null)}
                                  aria-label={`Reconhecimento Top. Equivale a 200 pontos. ${GetMoedaDescription('mandou')}`}
                                  className={`${!coin || coin === 'mandou' ? '' : 'opacity-50'} ${
                                    !hasEnoughCoins('mandou') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-2 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-col space-y-2 items-center mb-3">
                                    <div className="coin mandou flex-1">
                                      <MandouBem size={50} />
                                    </div>
                                    <div className="font-normal text-xs leading-tight text-white">Top</div>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {!hasEnoughCoins('mandou') ? 'Saldo insuficiente' : '200 pontos'}
                                  </p>
                                </button>
                                <button
                                  disabled={!hasEnoughCoins('valeu')}
                                  onClick={() => (hasEnoughCoins('valeu') ? setCoin('valeu') : null)}
                                  aria-label={`Reconhecimento  Valeu. Equivale a 100 pontos. ${GetMoedaDescription('valeu')}`}
                                  className={`${!coin || coin === 'valeu' ? '' : 'opacity-50'} ${
                                    !hasEnoughCoins('valeu') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-3 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-col space-y-2 items-center mb-3">
                                    <div className="coin flex-1">
                                      <Valeu size={50} />
                                    </div>
                                    <p className="font-normal text-xs leading-tight text-white">Curti</p>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {!hasEnoughCoins('valeu') ? 'Saldo insuficiente' : '100 pontos'}
                                  </p>
                                </button>

                                {!!coin && (
                                  <div
                                    aria-hidden={true}
                                    dangerouslySetInnerHTML={{
                                      __html: GetMoedaDescription(coin),
                                    }}
                                    className="text-elem font-thin text-xs text-electric-blue block leading-tight"
                                  ></div>
                                )}
                              </div>
                            </div>

                            <div className="lg:hidden">
                              <div
                                className={`w-full grid grid-cols-1 gap-y-4 moedas bg-oxford-blue-2 rounded-lg w-full py-4 px-8 lg:flex lg:flex-row items-center justify-between mt-5 text-xs lg:text-md text-yellow`}
                              >
                                <button
                                  disabled={!hasEnoughCoins('uau')}
                                  onClick={() => (hasEnoughCoins('uau') ? setCoin('uau') : null)}
                                  className={`${!coin || coin === 'uau' ? '' : 'opacity-50'} ${
                                    !hasEnoughCoins('uau') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-1 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-col lg:flex-row items-center lg:space-x-2 mb-3">
                                    <div className="coin flex-1">
                                      <Uau size={20} />
                                    </div>
                                    <p className="font-normal text-xs leading-tight text-white">Arrasou</p>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {!hasEnoughCoins('uau') ? 'Saldo insuficiente' : '300 pontos'}
                                  </p>
                                </button>
                                <button
                                  disabled={!hasEnoughCoins('mandou')}
                                  onClick={() => (hasEnoughCoins('mandou') ? setCoin('mandou') : null)}
                                  className={`${!coin || coin === 'mandou' ? '' : 'opacity-50'} ${
                                    !hasEnoughCoins('mandou') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-2 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-col lg:flex-row items-center lg:space-x-2 mb-3">
                                    <div className="coin mandou flex-1">
                                      <MandouBem size={20} />
                                    </div>
                                    <div className="font-normal text-xs leading-tight text-white">Top</div>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {!hasEnoughCoins('mandou') ? 'Saldo insuficiente' : '200 pontos'}
                                  </p>
                                </button>
                                <button
                                  disabled={!hasEnoughCoins('valeu')}
                                  onClick={() => (hasEnoughCoins('valeu') ? setCoin('valeu') : null)}
                                  className={`${!coin || coin === 'valeu' ? '' : 'opacity-50'} ${
                                    !hasEnoughCoins('valeu') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-3 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-row items-center lg:space-x-2 mb-3">
                                    <div className="coin flex-1">
                                      <Valeu size={20} />
                                    </div>
                                    <p className="font-normal text-xs leading-tight text-white">Curti</p>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {!hasEnoughCoins('valeu') ? 'Saldo insuficiente' : '100 pontos'}
                                  </p>
                                </button>

                                {!!coin && (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: GetMoedaDescription(coin),
                                    }}
                                    className="text-elem font-thin text-xs text-electric-blue block leading-tight"
                                  ></div>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {step === 3 && target && behavior && coin && (
                      <div className="bg-oxford-blue-2 rounded-lg w-full py-4 px-8 block step_3" ref={feedbackRef}>
                        <h2
                          className="block font-thin text-white text-base leading-none mb-3"
                          aria-label={` Agora conte a ${
                            target?.extra?.nome_guerra ? target?.extra?.nome_guerra : target?.name?.split(' ')[0]
                          } o motivo de ganhar ${GetMoedaLabel(coin).replace('#', 'hashtag')} em ${GetBehaviorLabel(behavior)}`}
                          tabIndex={0}
                        >
                          Agora conte a{' '}
                          <strong className="uppercase">
                            {target?.extra?.nome_guerra ? target?.extra?.nome_guerra : target?.name?.split(' ')[0]}
                          </strong>{' '}
                          o motivo de ganhar <span className="text-electric-blue">{GetMoedaLabel(coin)}</span> em{' '}
                          <span className="text-electric-blue">{GetBehaviorLabel(behavior)}</span>!
                        </h2>
                        <div className="flex flex-row items-center">
                          <div className="h-48 w-full bg-transparent">
                            <TextEditor
                              initialValue={message}
                              onChange={handleChangeMessage}
                              minLength={minTextLength}
                              maxLength={maxTextLength}
                            />
                          </div>

                          {/* <textarea
                              ref={(ref) => (messageRef.current = ref)}
                              onChange={(e) => setMessage(e.target.value)}
                              className="h-28 w-full bg-transparent p-2"
                              style={{ fontSize: 16 }}
                            ></textarea> */}
                          {/* <button className="text-blue-light p-2 hidden md:block" onClick={toggleEmoji}>
                              <BiSmile size={24} />
                            </button> */}
                        </div>

                        {messageLength && messageLength.fullLength > 0 && messageLength.textLength < minTextLength && (
                          <p className="text-yellow mt-5" tabIndex={0}>
                            Para continuar, insira pelo menos {minTextLength} caracteres no campo de texto, sem contar os emojis.
                          </p>
                        )}

                        {messageLength && messageLength.fullLength > 0 && messageLength.fullLength > maxTextLength && (
                          <p className="text-yellow mt-5" tabIndex={0}>
                            O texto inserido ultrapassou o limite máximo de {maxTextLength} caracteres.
                          </p>
                        )}

                        <div className="text-yellow flex items-start space-x-2 mt-5">
                          <AiOutlineWarning size={30} />
                          <p className="text-white">
                            Todos os reconhecimentos que você enviar ficarão visíveis aos outros participantes. Ética e
                            Integridade são as bases da confiança.
                          </p>
                        </div>
                      </div>
                    )}

                    {step === 4 && target && behavior && coin && (
                      <div className="space-y-6 ">
                        <div className="text-yellow flex items-center space-x-2 pr-2">
                          <span className="block w-[30px] flex-1">
                            <AiOutlineWarning size={30} className="flex-1" />
                          </span>
                          <p className="text-white">
                            Depois de enviar o reconhecimento, você ainda poderá cancelar nos próximos 15 minutos. Além disso, é
                            possível editar ou solicitar a devolução ao destinatário até 10 dias após o envio (seus pontos só
                            serão estornados até o final do mês do envio). Deseja enviar esse reconhecimento?
                          </p>
                        </div>

                        <div className="bg-oxford-blue-2 rounded-lg w-full py-4 px-8 block step_4">
                          <div className="bg-maastricht-blue-3 rounded-xl text-gray-300 space-y-2 py-6 px-6 lg:px-8">
                            <div className="flex flex-col lg:flex-col items-start lg:items-start mb-5">
                              <div className="flex-1 flex flex-col-reverse lg:flex-row items-start space-x-2 leading-tight w-full">
                                <div className="flex flex-1 w-full items-start">
                                  {user && (
                                    <div className="mr-2">
                                      <UserAvatar
                                        data={{
                                          image: target.image,
                                          ...target.extra,
                                        }}
                                      />
                                    </div>
                                  )}
                                  <div className="flex-1 w-full block">
                                    <Tippy
                                      allowHTML={true}
                                      content={
                                        <>
                                          <p className="m-0">
                                            Nome: <strong>{target?.name}</strong>
                                          </p>
                                          <p className="m-0">
                                            Função: <strong>{target?.extra?.funcao}</strong>
                                          </p>
                                          <p className="m-0">
                                            Área: <strong>{target?.extra?.diretoria}</strong>
                                          </p>
                                        </>
                                      }
                                    >
                                      <div className="w-fit block text-sm lg:text-base text-alice-blue font-thin">
                                        VOCÊ enviou para: <br />
                                        <span className="font-semibold">
                                          {target?.extra?.nome_guerra || target.name.split(' ')[0]}
                                        </span>{' '}
                                        ({target?._id})
                                        <BiInfoCircle className="inline relative -top-[2px] ml-1" />
                                      </div>
                                    </Tippy>

                                    <div>
                                      <span className="block text-xs font-thin">
                                        <span className="text-electric-blue uppercase">{target.extra?.diretoria}</span> -{' '}
                                        {target.extra?.prefixo} -{' '}
                                        <span className="text-electric-blue">{target.extra?.funcao} </span>
                                      </span>
                                    </div>

                                    <div className="block 2xl:flex flex-col 2xl:flex-row 2xl:items-center w-full space-y-2 2xl:space-y-0 2xl:space-x-2 mt-1">
                                      <div className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-yellow bg-oxford-blue rounded-full">
                                        {Coins[coin]} <span className="text-xs">{CoinLabel[coin]}</span>
                                      </div>
                                      <br className="block 2xl:hidden" />
                                      <div className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-yellow bg-oxford-blue rounded-full">
                                        {Behaviors[behavior]} <span className="text-xs">{BehaviorLabel[behavior]}</span>
                                      </div>
                                      <>
                                        <br className="block 2xl:hidden" />
                                        <div className="inline-flex items-center space-x-2">
                                          <div
                                            className={`ring-white whitespace-nowrap 2xl:mt-0 flex-1 2xl:flex-none inline-flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-electric-blue rounded-full`}
                                          >
                                            <span>
                                              total = {coin === 'valeu' ? 100 : coin === 'mandou' ? 200 : 300} pontos
                                            </span>{' '}
                                          </div>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <hr className="border-prussian-blue" />

                            <>
                              <div className="p-2 flex-1 flex-col">
                                <div className="flex justify-between mb-3">
                                  <p className="text-electric-blue font-thin">Reconhecimento enviado:</p>
                                </div>
                                {!!message && (
                                  <div
                                    className="text-alice-blue break-words"
                                    tabIndex={0}
                                    aria-label="Texto do reconhecimento enviado"
                                    dangerouslySetInnerHTML={{
                                      __html: convertEmojis(message),
                                    }}
                                  />
                                )}
                              </div>
                            </>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="flex justify-center flex-col items-center space-y-6">
                      <div className="p-2 px-45 flex flex-row space-x-8 items-center justify-center">
                        {step === 0 && !target && !!searchResults && searchResults.length > 0 && (
                          <button
                            onClick={() => reset()}
                            className={`leading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Voltar</p>
                          </button>
                        )}

                        {step > 0 && (
                          <button
                            onClick={() => setStep(step - 1)}
                            aria-label={`Voltar para etapa ${step} de reconhecimento`}
                            className={`leading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Voltar</p>
                          </button>
                        )}

                        {step < 3 && (
                          <button
                            disabled={
                              (step === 0 && !target) ||
                              (step === 1 && !behavior) ||
                              (step === 2 && !coin) ||
                              (step === 3 && !message)
                            }
                            onClick={() => setStep(step + 1)}
                            aria-label={`Continuar e ir para etapa ${step + 1}. Habilitado`}
                            className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Continuar</p>
                          </button>
                        )}

                        {step === 3 && (
                          <>
                            <button
                              disabled={
                                !message ||
                                !messageLength ||
                                messageLength.textLength < minTextLength ||
                                messageLength.fullLength > maxTextLength
                              }
                              onClick={() => setStep(step + 1)}
                              aria-label={`Revisar reconhecimento`}
                              className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                            >
                              <p className="font-bold text-sm leading-none uppercase">Revisar</p>
                            </button>
                          </>
                        )}

                        {step === 4 && (
                          <button
                            disabled={
                              !message ||
                              !messageLength ||
                              messageLength.textLength < minTextLength ||
                              messageLength.fullLength > maxTextLength
                            }
                            onClick={() => handleSubmit()}
                            aria-label={`Enviar reconhecimento`}
                            className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Enviar</p>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {loading && !submitted && (
                  <div className="space-y-4 mt-12">
                    <div className="flex flex-row items-center justify-center text-xl text-yellow animate-pulse">
                      <div></div>
                      Enviando reconhecimento...
                    </div>
                  </div>
                )}
              </div>
            </Box>
          )}

          {submitted && (
            <div
              className="border-2 rounded-3xl p-3 relative bg-oxford-blue border-electric-blue p-8 flex flex-col w-[324px] lg:max-w-screen-md justify-center items-center"
              ref={feedbackServer}
              tabIndex={0}
            >
              <button
                className="absolute -top-5 -right-5 button-close"
                tabIndex={0}
                aria-label="Fechar modal de feedback"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                <IoMdCloseCircle size={48} className="text-slate-blue" />
              </button>

              <div className="flex flex-col items-center justify-center">
                {!hasSubmitError && (
                  <>
                    <div className="flex items-center justify-center mb-6">
                      <img
                        src={getImgFeedback(coin || '')}
                        alt={coin === 'mandou' ? 'Top!' : coin === 'uau' ? 'Arrasou!' : 'Curti!'}
                        className="w-[173px] block"
                      />
                    </div>
                    <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center" tabIndex={0}>
                      {coin === 'mandou' ? 'Top!' : coin === 'uau' ? 'Arrasou!' : 'Curti!'}
                    </h1>
                    <p className="text-sm font-white font-light text-center block" tabIndex={0}>
                      {submitMessage}
                    </p>
                  </>
                )}

                {hasSubmitError && (
                  <>
                    <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center" tabIndex={0}>
                      Não foi possível enviar o reconhecimento!
                    </h1>
                    <p className="text-sm font-white font-light text-center block mb-8" tabIndex={0}>
                      {submitMessage}
                    </p>
                    {showRetryButton() && (
                      <button
                        onClick={() => reset()}
                        tabIndex={0}
                        className={`leading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                      >
                        Tentar novamente
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          )}

          {showModalItem && (
            <Modal
              onClose={clear => {
                setshowModalItemItem(false);
                if (clear) {
                  setTarget(undefined);
                }
              }}
            />
          )}
        </>
      )}
    />
  );
}
